import React, { useState } from "react";
import FluentUiIcon from "../../../../../../assets/fluent-ui-icon";
import { FluentMenu } from "../../../../../../components/FluentUI/Fluent-Menu";
import { FluentTooltip } from "../../../../../../components/FluentUI/Fluent-Tooltip";
import PropTypes from "prop-types";
import { RenameDialog } from "./rename-dialog";
import { ParseContextMenuItems, LabelBlurUtil } from "./form-design-util";
import { DeleteDialog } from "../common-components/delete-dialog";

export const ViewFormsItem = ({
  allFormNames,
  setFormView,
  form,
  RenameForm,
  DeleteForm,
}) => {
  const [dialog2, setDialog2] = useState({
    delete: false,
    rename: false,
  });

  const OnDeleteForm = () => {
    DeleteForm(form.DisplayOrder);
    setDialog2((prev) => ({ ...prev, delete: false }));
  };

  const OnSaveLabel = (label) => {
    RenameForm(label, form.DisplayOrder);
    setDialog2((prev) => ({ ...prev, rename: false }));
  };

  const OnBlurLabel = (label) => {
    return LabelBlurUtil(allFormNames, form.DisplayOrder, label);
  };

  const ContextMenuClick = (e, identifier) => {
    e.stopPropagation();
    switch (identifier) {
      case "Delete":
        setDialog2((prev) => ({ ...prev, delete: true }));
        break;
      case "Rename":
        setDialog2((prev) => ({ ...prev, rename: true }));
        break;
      case "Edit":
        setFormView({ isAllForm: false, displayOrderForm: form.DisplayOrder });
        break;
      default:
        break;
    }
  };

  const OnEditForm = (e) => {
    if (!(e.target instanceof SVGElement)) {
      ContextMenuClick(e, "Edit");
    }
  };

  return (
    <div className="view-forms-list-content-item">
      <div className="view-forms-list-content-item-icon">
        <FluentUiIcon name={"FormRegular"} color={"#0F6CBD"} size={20} />
      </div>
      <div className="view-forms-list-content-item-info" onClick={OnEditForm}>
        <FluentTooltip
          target={
            <div className="view-forms-list-content-item-info-name">
              {form.Label}
            </div>
          }
          text={form.Label}
        ></FluentTooltip>
        {/* <div className="view-forms-list-content-item-info-date">11/06/2023</div> */}
      </div>
      <FluentMenu
        button={
          <FluentUiIcon
            name={"MoreHorizontalRegular"}
            color={"#212121"}
            size={20}
          ></FluentUiIcon>
        }
        items={ParseContextMenuItems(ContextMenuClick)}
      ></FluentMenu>
      {dialog2.delete && (
        <DeleteDialog
          identifier="Form"
          open={dialog2.delete}
          OnCancel={() => setDialog2((prev) => ({ ...prev, delete: false }))}
          OnDelete={OnDeleteForm}
        ></DeleteDialog>
      )}
      {dialog2.rename && (
        <RenameDialog
          open={dialog2.rename}
          OnCancel={() => setDialog2((prev) => ({ ...prev, rename: false }))}
          OnSave={OnSaveLabel}
          OnBlurLabel={OnBlurLabel}
          text={form.Label}
        ></RenameDialog>
      )}
    </div>
  );
};

ViewFormsItem.propTypes = {
  allFormNames: PropTypes.array,
  setFormView: PropTypes.func,
  form: PropTypes.object,
  RenameForm: PropTypes.func,
  DeleteForm: PropTypes.func,
};
